export default __webpack_public_path__ + "static/media/1442.3f204eb9.png";